import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  updatedList: null,
  justAddedSymbol: false,
  pendingRefresh: false,
  requireFullRefresh: false, // Yeni flag eklendi
  historyDataFetched: false, // Flag to track if history data has been fetched
  historyDataLoading: false, // Flag to track if history data is loading
  initialDataReceived: false, // Track when initial data is received
  loadingPriority: 'history', // Priority mode: 'history' or 'streaming'
};

export const watchlistTableSearchItemSlice = createSlice({
  name: 'watchlistTableSearchItem',
  initialState,
  reducers: {
    setUpdatedList: (state, action) => {
      state.updatedList = action.payload;
      // Eğer requireFullRefresh flag'i varsa, pendingRefresh'i de true yap
      if (action.payload?.requireFullRefresh) {
        state.pendingRefresh = true;
        state.requireFullRefresh = true;
        // When updating list, reset history data flags
        state.historyDataFetched = false;
        state.initialDataReceived = false;
      }
    },
    setJustAddedSymbol: (state, action) => {
      state.justAddedSymbol = action.payload;
    },
    setPendingRefresh: (state, action) => {
      state.pendingRefresh = action.payload;
      // pendingRefresh false yapılırsa, requireFullRefresh'i de sıfırla
      if (action.payload === false) {
        state.requireFullRefresh = false;
      }
    },
    setHistoryDataFetched: (state, action) => {
      state.historyDataFetched = action.payload;
    },
    setHistoryDataLoading: (state, action) => {
      state.historyDataLoading = action.payload;
    },
    setInitialDataReceived: (state, action) => {
      state.initialDataReceived = action.payload;
    },
    setLoadingPriority: (state, action) => {
      state.loadingPriority = action.payload;
    },
  },
});

export const { 
    setSelectedSearchItem, 
    setUpdatedList, 
    setJustAddedSymbol,
    setPendingRefresh,
    setHistoryDataFetched,
    setHistoryDataLoading,
    setInitialDataReceived,
    setLoadingPriority,
    PENDING_INDICATOR_UPDATE,
    INDICATOR_UPDATE_COMPLETED
} = watchlistTableSearchItemSlice.actions;


export default watchlistTableSearchItemSlice.reducer;
